import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
    loadClaimEventStatuses,
    loadClaimEventTypes,
    loadClaimStatusUploaderTypes,
    loadUploaderTypes
} from '../../../store/directusService';

import ClaimStatusUploaderModal from './ClaimStatusUploaderModal';

const excludedClaimEventTypes = [
    'milestone 1',
    'milestone 2',
    'milestone 3',
    'milestone 4',
    'outcome'
];

const ClaimStatusUploader = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();

    // LOCAL STATE
    const [isClaimStatusUploaderModalOpen, setIsClaimStatusUploaderModalOpen] = useState(false);
    const [claimStatuses, setClaimStatuses] = useState([]);
    const [filteredClaimEventTypes, setFilteredClaimEventTypes] = useState([]);
    const [enabledContracts, setEnabledContracts] = useState([]);

    // STORE STATE
    const claimStatusUploaderTypes = useSelector(
        (state) => state.entities.directusService.claimStatusUploaderTypes
    );
    const claimEventStatuses = useSelector(
        (state) => state.entities.directusService.claimEventStatuses
    );
    const claimEventTypes = useSelector((state) => state.entities.directusService.claimEventTypes);
    const uploaderTypes = useSelector((state) => state.entities.directusService.uploaderTypes);

    // USE EFFECTS
    useEffect(() => {
        if (uploaderTypes?.length < 1) dispatch(loadUploaderTypes());
        if (claimStatusUploaderTypes?.length < 1) dispatch(loadClaimStatusUploaderTypes());
        if (claimEventStatuses?.length < 1) dispatch(loadClaimEventStatuses());
        if (claimEventTypes?.length < 1) dispatch(loadClaimEventTypes());
    }, []);

    useEffect(() => {
        if (!uploaderTypes.length) return;
        const validContracts = uploaderTypes
            .find((el) => el.name.toLowerCase() === 'claim status uploader')
            ?.contract.map((el) => el.contract_id);

        setEnabledContracts(validContracts);
    }, [uploaderTypes]);

    useEffect(() => {
        if (claimEventStatuses?.length < 1) return;
        const filtered = claimEventStatuses.filter(
            (el) =>
                el.name.toLowerCase() === 'claimed' ||
                el.name.toLowerCase() === 'verified' ||
                el.name.toLowerCase() === 'logged'
        );
        setClaimStatuses(filtered);
    }, [claimEventStatuses]);

    useEffect(() => {
        if (claimEventTypes?.length < 1) return;
        setFilteredClaimEventTypes(
            claimEventTypes.filter((el) => !excludedClaimEventTypes.includes(el.name.toLowerCase()))
        );
    }, [claimEventTypes]);

    useEffect(() => {
        setIsClaimStatusUploaderModalOpen(isOpen);
    }, [isOpen]);

    const onClaimStatusUploaderModalClose = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        setIsClaimStatusUploaderModalOpen(false);
        onClose();
    };

    const onCancel = () => {
        setIsClaimStatusUploaderModalOpen(false);
        onClose();
    };

    return (
        <ClaimStatusUploaderModal
            contracts={enabledContracts}
            claimStatusUploaderTypes={claimStatusUploaderTypes}
            claimStatuses={claimStatuses}
            claimTypes={filteredClaimEventTypes}
            onClose={onClaimStatusUploaderModalClose}
            isOpen={isClaimStatusUploaderModalOpen}
            onCancel={onCancel}
        />
    );
};

export default ClaimStatusUploader;

ClaimStatusUploader.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
};
